import { useSelector } from "react-redux";
import { getAuthClaims } from "@redriver/cinnamon";
import { claimExists } from "features/../../../shared/components/auth/utils";
import { getSheetDataState } from "features/Sheets";

const useImpersonatedPermission = (target, action, any = false) => {
  const { impersonatedUser } = useSelector(getSheetDataState);
  const { permissions: userPermissions } = useSelector(getAuthClaims);
  const hasUserPermission = claimExists(userPermissions, target, action, any);

  if (
    impersonatedUser?.userType == null ||
    impersonatedUser?.permissions == null
  ) {
    return hasUserPermission;
  }

  const hasImpersonatedPermission = claimExists(
    impersonatedUser.permissions,
    target,
    action,
    any,
  );

  return hasUserPermission && hasImpersonatedPermission;
};

export default useImpersonatedPermission;
